"use strict";

/* Vendor */
const jQuery = require("jquery");
window.jQuery = window.$ = jQuery;

require("../../node_modules/fancybox/dist/js/jquery.fancybox.js");
require("jquery-zoom");

/* Components */
import menu from "./components/menu";
import banner from "./components/banner";
import audio from './components/audio';
import video from "./components/video";

/* Helpers */
import loadMore from "./helpers/loadMore";

/* App */


(function($){
	$(document).ready(() => {
		menu();
		audio($);
		video($);
		layout($);
		banner().init(".slider");

		$(window).on("scroll", function(){
			const scrollTop = $(window).scrollTop();
			if(scrollTop > 50){
				$(".toTop").addClass('toTop--visible')
			}else{
				$(".toTop").removeClass('toTop--visible')
			}
			
		});

		$(".link--load-more").on("click", function(e){
			e.preventDefault();
			loadMore( this, $, ()=>layout($));
		});


		$( ".fancybox" ).fancybox({
			type: "image",
			helpers : {
				title: {
					type: "inside"
				}
			}
		});
		$(".shop__item-image").each(function(){
			console.log(this);
			$(this).zoom({url: this.href});
		})
		$(window).on('resize', function(){
			video($);
			layout($);
		});
	});	
	const layout = ($) => {
		const windowHeight = $(window).outerHeight();
		const header = $('.header');
		const footer = $('.footer');
		const innerHeight = windowHeight - header.outerHeight() - footer.outerHeight();
		const main = $('.main');
		if(main.outerHeight() < innerHeight){
			main.css({'min-height': innerHeight+'px'});
		}
		const sidebarContent = $('.sidebar').find(".tours")[0] || $('.sidebar').find(".sounds")[0];
		const cssSidebarContentHeight = getStyleSheetPropertyValue("."+sidebarContent.classList[0], "height");
		const mainHeight = main.outerHeight();
		if(mainHeight > cssSidebarContentHeight){
			$(sidebarContent).css("height", mainHeight);
		}
	};
	function getStyleSheetPropertyValue(selectorText, propertyName) {
		// search backwards because the last match is more likely the right one
		for (var s= document.styleSheets.length - 1; s >= 0; s--) {
			var cssRules = document.styleSheets[s].cssRules || document.styleSheets[s].rules || []; // IE support
			for (var c=0; c < cssRules.length; c++) {
				if (cssRules[c].selectorText === selectorText) 
					return cssRules[c].style[propertyName];
			}
		}
		return null;
	}

})(jQuery);
